export const initialValues = {
  title: "",
  sub_title: "",
  description: "",
  location: "",
  event_location: "",
  instagram_link: "",
  facebook_link: "",
  whatsapp_link: "",
  added_by: "",
  start_date: "",
  end_date: null,
  start_time: "",
  end_time: null,
  event_registration_link: [
    {
      title: "",
      link: "",
      button_title: "",
      is_show: 0,
      display_order: 1,
    },
  ],
  latitude: "",
  longitude: "",
  is_active: 0,
  event_images: null,
  is_popular: 0,
  event_advertisements: [],
  max_attendees: 0,
  booking_amount: 0,
  member_price: 0,
  special_price: 0,
  member_only: 0,
  is_hide_total_bookings: 0,
  is_allow_guest_booking: 0,
  guest_limit_for_booking: 0,
  guest_price: 0,
  is_online_booking_available: 0,
};

export const updateInitialValues = {
  title: "",
  sub_title: "",
  description: "",
  location: "",
  event_location: "",
  instagram_link: "",
  facebook_link: "",
  whatsapp_link: "",
  added_by: "",
  start_date: "",
  end_date: null,
  start_time: "",
  end_time: null,
  event_registration_link: [],
  is_active: 0,
  event_images: null,
  is_popular: 0,
  latitude: "",
  longitude: "",
  event_advertisements: [],
  max_attendees: 0,
  booking_amount: 0,
  member_price: 0,
  special_price: 0,
  member_only: 0,
  is_hide_total_bookings: 0,
  is_allow_guest_booking: 0,
  guest_limit_for_booking: 0,
  guest_price: 0,
  is_online_booking_available: 0,
};
